import { ReactNode } from 'react';
import { TextInputField, TextInputFieldProps } from '@shared/components';
import { useTheme } from '@mui/material';
import { EditableValue } from './EditableValue';
import { Validator } from './Validator';

interface EditableTextValueProps {
  editable: boolean;
  renderValue: () => ReactNode;
  onSave: (value: string) => void;
  defaultValue: string;
  multiline?: boolean;
  maxLength?: number;
  validate?: Validator<string>;
  inputProps?: TextInputFieldProps;
}

export const EditableTextValue = ({
  editable,
  renderValue,
  onSave,
  defaultValue,
  multiline,
  maxLength,
  validate,
  inputProps = {},
}: EditableTextValueProps) => {
  const { shape } = useTheme();

  return (
    <EditableValue
      editable={editable}
      renderValue={renderValue}
      defaultValue={defaultValue}
      buttonsPlacement="right"
      onSave={onSave}
      validate={validate}
      renderInput={({ value, onChange, error }) => (
        <TextInputField
          value={value}
          onChange={(e) => onChange(e.target.value)}
          error={error}
          size="small"
          autoFocus
          margin="none"
          multiline={multiline}
          inputSx={{ minWidth: '320px' }}
          maxContentLength={maxLength}
          helperTextSx={{
            position: 'absolute',
            right: 0,
            width: '100%',
            bgcolor: 'background.paper',
            zIndex: 1,
            boxShadow: '2px 2px 3px 0px',
            borderRadius: Number(shape.borderRadius) / 2,
          }}
          fullWidth
          {...inputProps}
        />
      )}
    />
  );
};
